import { CONTENT_REWRITE } from '../../constants/CopilotInAppActionTypes';
export const convertContentRewriteAction = inAppActionLegacy => {
  return {
    name: CONTENT_REWRITE,
    arguments: {
      '@type': 'map',
      value: {
        selectedText: {
          '@type': 'string',
          value: inAppActionLegacy.text
        },
        operation: {
          '@type': 'string',
          value: inAppActionLegacy.operation
        },
        editorText: {
          '@type': 'string',
          value: inAppActionLegacy.editorText || ''
        },
        precedingText: {
          '@type': 'string',
          value: inAppActionLegacy.precedingText || ''
        },
        followingText: {
          '@type': 'string',
          value: inAppActionLegacy.followingText || ''
        },
        brandVoiceChannel: {
          '@type': 'string',
          value: inAppActionLegacy.brandVoiceChannel || ''
        },
        brandVoiceSubChannel: {
          '@type': 'string',
          value: inAppActionLegacy.brandVoiceSubChannel || ''
        },
        businessUnitId: {
          '@type': 'integer',
          value: inAppActionLegacy.businessUnitId || 0
        },
        language: {
          '@type': 'string',
          value: inAppActionLegacy.contentLanguage || ''
        }
      }
    }
  };
};